import { render, staticRenderFns } from "./fancyEditor.vue?vue&type=template&id=76a9b0bf"
import script from "./fancyEditor.vue?vue&type=script&lang=js"
export * from "./fancyEditor.vue?vue&type=script&lang=js"
import style0 from "./fancyEditor.vue?vue&type=style&index=0&id=76a9b0bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fancyEditor.vue"
export default component.exports